import React, {Component, Fragment} from 'react';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import TokenManageForm from '../../../../containers/TokenManageFrom';
import ModalManager from '../../../../components/modal/ModalManager';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {NotificationManager} from '../../../../components/common/react-notifications';
import ReactTableSelectFilter from "../../../../components/ReactTableSelectFilter";
import TokenSettings from "../../../../containers/TokenSettings";
import {reactTableText} from '../../../../constants/configs';
import {filter, find, keyBy, mapValues, omit} from 'lodash';
import Rbac from '../../../../components/Rbac';
import {withTranslation} from 'react-i18next';
import Api from '../../../../services/Api';
import ReactTable from 'react-table';
import {i18nizeDate} from "../../../../helpers/Utils";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tokens: [],
      allTokens: [],
      loading: true,
      expanded: {},
    };
    this.renderTokenFilter = this.renderTokenFilter.bind(this);
    this.renderTokenNameCell = this.renderTokenNameCell.bind(this);
  }

  fetchData = async state => {
    this.setState({loading: true});
    await this.fetchTokens(state);
    this.setState({loading: false});
  };

  fetchTokens = async state => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/tokens', undefined, {
        params: {
          ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
        },
      });
      this.setState({
        tokens: data.tokens,
        ...(!state.filtered.length ? {allTokens: data.tokens} : null),
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  deleteToken = async symbol => {
    const {t} = this.props;
    try {
      await Api.invoke('DELETE', `/v2/admin-ui/tokens/${symbol}`);
      NotificationManager.success(t('Token {{symbol}} deleted successfully', {symbol}), t('Message'));
      this.setState({
        tokens: filter(this.state.tokens, obj => obj.symbol !== symbol),
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onPressCreate = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Add new token'),
      body: <TokenManageForm afterSubmit={async () => {await this.fetchTokens(this.table.state);}}/>
    });
  };

  onPressEdit = token => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Edit {{symbol}} token', {symbol: token.symbol}),
      body: <TokenManageForm token={token} afterSubmit={async () => {await this.fetchTokens(this.table.state);}}/>
    });
  };

  onPressDelete = symbol => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete token {{symbol}} ?', {symbol}),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.deleteToken(symbol);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Yes'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('No'),
        },
      ],
    });
  };

  getColumns = t => [
    {
      Header: t('Symbol'),
      accessor: 'symbol',
      minWidth: 150,
      filterable: true,
      Filter: this.renderTokenFilter,
      Cell: this.renderTokenNameCell,
    },
    {
      Header: t('English Name'),
      accessor: 'labels',
      Cell: props => <span>{find(props.value, {locale: "en"})?.value}</span>,
    },
    {
      Header: t('Farsi Name'),
      accessor: 'labels',
      Cell: props => <span>{find(props.value, {locale: "fa"})?.value}</span>,
    },
    {
      Header: t('Type'),
      accessor: 'tokenType',
    },
    {
      Header: t('Decimal Precision'),
      accessor: 'decimalPrecision',
    },
    {
      Header: t('Display Decimal'),
      accessor: 'displayDecimal',
    },
    {
      Header: t('Estimated List Date'),
      accessor: 'releasedAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 180,
    },
    {
      Header: t('List Date'),
      accessor: 'listedAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 160,
    },
    {
      Header: t('Status'),
      accessor: 'active',
      Cell: props => {
        return (
          <span className={`font-weight-semibold ${props.value ? 'text-success' : 'text-danger'}`}>
            {props.value ? t('Enabled') : t('Disabled')}
          </span>
        );
      },
      width: 100,
    },
    {
      Header: t('Actions'),
      width: 100,
      accessor: 'symbol',
      Cell: props => <div className='d-flex flex-row align-items-center'>
        <i
          className="simple-icon-pencil edit-icon mr-4 cursor-pointer"
          onClick={() => {this.onPressEdit(props.original);}}
        />
        <i
          className="simple-icon-trash delete-icon cursor-pointer"
          onClick={() => {this.onPressDelete(props.value);}}
        />
      </div>,
    },
  ];

  renderTokenFilter({filter, onChange}) {
    const {t} = this.props;
    const options = this.state.allTokens.map(token => ({
      value: token.symbol, label: token.symbol,
    }));
    return <ReactTableSelectFilter
      width="50%"
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  renderTokenNameCell = props => {
    const {symbol, name, logoUrl} = props.original;
    return (
      <div className='d-flex flex-row align-items-center'>
        <img
          width={60}
          alt={name || symbol}
          className="avatar-mini"
          src={logoUrl || '/assets/img/noimage.jpg'}
        />
        <span className='mx-3 font-weight-semibold text-one'>{symbol}</span>
        <span className='mx-3'>{name}</span>
      </div>
    );
  };


  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  render() {
    const {t, match} = this.props;
    const {tokens, loading, expanded} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary d-flex flex-row justify-content-between align-items-center">
                  {t('Tokens List')}
                  <Rbac permission='create_admin-users'>
                    <Button onClick={this.onPressCreate}>
                      <i className="simple-icon-plus add-reply-icon"/>
                      <span className="mx-1">{t('Add New Token')}</span>
                    </Button>
                  </Rbac>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  onFetchData={this.fetchData}
                  className="-highlight"
                  data={tokens}
                  loading={loading}
                  expanded={expanded}
                  sortable={false}
                  resizable={true}
                  showPagination={false}
                  columns={this.getColumns(t)}
                  onExpandedChange={this.onExpanded}
                  pageSize={tokens.length || 10}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={({original}) => {
                    return (
                      <TokenSettings
                        settings={original.setting}
                        token={original.symbol}
                        listedAt={original.listedAt}
                        releasedAt={original.releasedAt}
                      />
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
